export enum ActionType {
  EDIT = "edit",
  EDIT_MULTIPLE = "edit_multiple",
  DELETE = "delete",
}
